import { render, staticRenderFns } from "./ResellerProductAccess.vue?vue&type=template&id=795cf254"
import script from "./ResellerProductAccess.vue?vue&type=script&lang=js"
export * from "./ResellerProductAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports